module.exports = __webpack_public_path__ + "img/QR2.694dfc1b.png";